// Generated by ./scripts/gen_openapi.ts

/** PATHS **/

// /api/account
export type ACCOUNT_REQUEST_PARAMS = Record<string, never>;
export type ACCOUNT_REQUEST_PATH = `/api/account`;
export type ACCOUNT_UPDATE_REQUEST_PARAMS = Record<string, never>;
export type ACCOUNT_UPDATE_REQUEST_PATH = `/api/account`;
export type ACCOUNT_UPDATE_REQUEST_BODY = AccountUpdateRequest;

// /api/backup
export type CREATE_BACKUP_REQUEST_PARAMS = Record<string, never>;
export type CREATE_BACKUP_REQUEST_PATH = `/api/backup`;

// /api/data_entries/{data_entry_id}
export interface DATA_ENTRY_RESET_REQUEST_PARAMS {
  data_entry_id: DataEntryId;
}
export type DATA_ENTRY_RESET_REQUEST_PATH = `/api/data_entries/${DataEntryId}`;

// /api/data_entries/{data_entry_id}/get
export interface DATA_ENTRY_GET_REQUEST_PARAMS {
  data_entry_id: DataEntryId;
}
export type DATA_ENTRY_GET_REQUEST_PATH = `/api/data_entries/${DataEntryId}/get`;

// /api/data_entries/{data_entry_id}/resolve_differences
export interface DATA_ENTRY_GET_DIFFERENCES_REQUEST_PARAMS {
  data_entry_id: DataEntryId;
}
export type DATA_ENTRY_GET_DIFFERENCES_REQUEST_PATH = `/api/data_entries/${DataEntryId}/resolve_differences`;
export interface DATA_ENTRY_RESOLVE_DIFFERENCES_REQUEST_PARAMS {
  data_entry_id: DataEntryId;
}
export type DATA_ENTRY_RESOLVE_DIFFERENCES_REQUEST_PATH = `/api/data_entries/${DataEntryId}/resolve_differences`;
export type DATA_ENTRY_RESOLVE_DIFFERENCES_REQUEST_BODY = ResolveDifferencesAction;

// /api/data_entries/{data_entry_id}/resolve_errors
export interface DATA_ENTRY_RESOLVE_ERRORS_REQUEST_PARAMS {
  data_entry_id: DataEntryId;
}
export type DATA_ENTRY_RESOLVE_ERRORS_REQUEST_PATH = `/api/data_entries/${DataEntryId}/resolve_errors`;
export type DATA_ENTRY_RESOLVE_ERRORS_REQUEST_BODY = ResolveErrorsAction;

// /api/data_entries/{data_entry_id}/{entry_number}
export interface DATA_ENTRY_SAVE_REQUEST_PARAMS {
  data_entry_id: DataEntryId;
  entry_number: number;
}
export type DATA_ENTRY_SAVE_REQUEST_PATH = `/api/data_entries/${DataEntryId}/${number}`;
export type DATA_ENTRY_SAVE_REQUEST_BODY = DataEntry;
export interface DATA_ENTRY_DISCARD_REQUEST_PARAMS {
  data_entry_id: DataEntryId;
  entry_number: number;
}
export type DATA_ENTRY_DISCARD_REQUEST_PATH = `/api/data_entries/${DataEntryId}/${number}`;

// /api/data_entries/{data_entry_id}/{entry_number}/claim
export interface DATA_ENTRY_CLAIM_REQUEST_PARAMS {
  data_entry_id: DataEntryId;
  entry_number: number;
}
export type DATA_ENTRY_CLAIM_REQUEST_PATH = `/api/data_entries/${DataEntryId}/${number}/claim`;

// /api/data_entries/{data_entry_id}/{entry_number}/finalise
export interface DATA_ENTRY_FINALISE_REQUEST_PARAMS {
  data_entry_id: DataEntryId;
  entry_number: number;
}
export type DATA_ENTRY_FINALISE_REQUEST_PATH = `/api/data_entries/${DataEntryId}/${number}/finalise`;

// /api/elections
export type ELECTION_LIST_REQUEST_PARAMS = Record<string, never>;
export type ELECTION_LIST_REQUEST_PATH = `/api/elections`;

// /api/elections/import
export type ELECTION_IMPORT_REQUEST_PARAMS = Record<string, never>;
export type ELECTION_IMPORT_REQUEST_PATH = `/api/elections/import`;
export type ELECTION_IMPORT_REQUEST_BODY = ElectionCreationRequest;

// /api/elections/import/validate
export type ELECTION_IMPORT_VALIDATE_REQUEST_PARAMS = Record<string, never>;
export type ELECTION_IMPORT_VALIDATE_REQUEST_PATH = `/api/elections/import/validate`;
export type ELECTION_IMPORT_VALIDATE_REQUEST_BODY = ElectionCreationValidateRequest;

// /api/elections/{election_id}
export interface ELECTION_DETAILS_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type ELECTION_DETAILS_REQUEST_PATH = `/api/elections/${ElectionId}`;

// /api/elections/{election_id}/apportionment
export interface PROCESS_APPORTIONMENT_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type PROCESS_APPORTIONMENT_REQUEST_PATH = `/api/elections/${ElectionId}/apportionment`;

// /api/elections/{election_id}/apportionment/add_candidate_drawn
export interface ADD_CANDIDATE_DRAWN_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type ADD_CANDIDATE_DRAWN_REQUEST_PATH = `/api/elections/${ElectionId}/apportionment/add_candidate_drawn`;
export type ADD_CANDIDATE_DRAWN_REQUEST_BODY = CandidateDrawn;

// /api/elections/{election_id}/apportionment/add_deceased_candidate
export interface ADD_DECEASED_CANDIDATE_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type ADD_DECEASED_CANDIDATE_REQUEST_PATH = `/api/elections/${ElectionId}/apportionment/add_deceased_candidate`;
export type ADD_DECEASED_CANDIDATE_REQUEST_BODY = DeceasedCandidate;

// /api/elections/{election_id}/apportionment/add_list_drawn
export interface ADD_LIST_DRAWN_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type ADD_LIST_DRAWN_REQUEST_PATH = `/api/elections/${ElectionId}/apportionment/add_list_drawn`;
export type ADD_LIST_DRAWN_REQUEST_BODY = ListDrawn;

// /api/elections/{election_id}/apportionment/delete_deceased_candidate
export interface DELETE_DECEASED_CANDIDATE_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type DELETE_DECEASED_CANDIDATE_REQUEST_PATH =
  `/api/elections/${ElectionId}/apportionment/delete_deceased_candidate`;
export type DELETE_DECEASED_CANDIDATE_REQUEST_BODY = DeceasedCandidate;

// /api/elections/{election_id}/apportionment/finalise_deceased_candidates
export interface FINALISE_DECEASED_CANDIDATES_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type FINALISE_DECEASED_CANDIDATES_REQUEST_PATH =
  `/api/elections/${ElectionId}/apportionment/finalise_deceased_candidates`;

// /api/elections/{election_id}/apportionment/register_deceased_candidates
export interface REGISTER_DECEASED_CANDIDATES_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type REGISTER_DECEASED_CANDIDATES_REQUEST_PATH =
  `/api/elections/${ElectionId}/apportionment/register_deceased_candidates`;

// /api/elections/{election_id}/apportionment/reset
export interface RESET_APPORTIONMENT_STATE_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type RESET_APPORTIONMENT_STATE_REQUEST_PATH = `/api/elections/${ElectionId}/apportionment/reset`;

// /api/elections/{election_id}/apportionment/skip_deceased_candidates
export interface SKIP_DECEASED_CANDIDATES_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type SKIP_DECEASED_CANDIDATES_REQUEST_PATH =
  `/api/elections/${ElectionId}/apportionment/skip_deceased_candidates`;

// /api/elections/{election_id}/apportionment/state
export interface GET_APPORTIONMENT_STATE_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type GET_APPORTIONMENT_STATE_REQUEST_PATH = `/api/elections/${ElectionId}/apportionment/state`;

// /api/elections/{election_id}/certificate
export interface CERTIFICATE_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type CERTIFICATE_REQUEST_PATH = `/api/elections/${ElectionId}/certificate`;

// /api/elections/{election_id}/certificate_details
export interface CERTIFICATE_DETAILS_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type CERTIFICATE_DETAILS_REQUEST_PATH = `/api/elections/${ElectionId}/certificate_details`;

// /api/elections/{election_id}/committee_sessions
export interface COMMITTEE_SESSION_CREATE_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type COMMITTEE_SESSION_CREATE_REQUEST_PATH = `/api/elections/${ElectionId}/committee_sessions`;

// /api/elections/{election_id}/committee_sessions/{committee_session_id}
export interface COMMITTEE_SESSION_UPDATE_REQUEST_PARAMS {
  election_id: ElectionId;
  committee_session_id: CommitteeSessionId;
}
export type COMMITTEE_SESSION_UPDATE_REQUEST_PATH =
  `/api/elections/${ElectionId}/committee_sessions/${CommitteeSessionId}`;
export type COMMITTEE_SESSION_UPDATE_REQUEST_BODY = CommitteeSessionUpdateRequest;
export interface COMMITTEE_SESSION_DELETE_REQUEST_PARAMS {
  election_id: ElectionId;
  committee_session_id: CommitteeSessionId;
}
export type COMMITTEE_SESSION_DELETE_REQUEST_PATH =
  `/api/elections/${ElectionId}/committee_sessions/${CommitteeSessionId}`;

// /api/elections/{election_id}/committee_sessions/{committee_session_id}/download_zip_attachment_csb
export interface ELECTION_DOWNLOAD_ZIP_ATTACHMENT_CSB_REQUEST_PARAMS {
  election_id: ElectionId;
  committee_session_id: CommitteeSessionId;
}
export type ELECTION_DOWNLOAD_ZIP_ATTACHMENT_CSB_REQUEST_PATH =
  `/api/elections/${ElectionId}/committee_sessions/${CommitteeSessionId}/download_zip_attachment_csb`;

// /api/elections/{election_id}/committee_sessions/{committee_session_id}/download_zip_results
export interface ELECTION_DOWNLOAD_ZIP_RESULTS_GSB_REQUEST_PARAMS {
  election_id: ElectionId;
  committee_session_id: CommitteeSessionId;
}
export type ELECTION_DOWNLOAD_ZIP_RESULTS_GSB_REQUEST_PATH =
  `/api/elections/${ElectionId}/committee_sessions/${CommitteeSessionId}/download_zip_results`;

// /api/elections/{election_id}/committee_sessions/{committee_session_id}/download_zip_results_csb
export interface ELECTION_DOWNLOAD_ZIP_RESULTS_CSB_REQUEST_PARAMS {
  election_id: ElectionId;
  committee_session_id: CommitteeSessionId;
}
export type ELECTION_DOWNLOAD_ZIP_RESULTS_CSB_REQUEST_PATH =
  `/api/elections/${ElectionId}/committee_sessions/${CommitteeSessionId}/download_zip_results_csb`;

// /api/elections/{election_id}/committee_sessions/{committee_session_id}/download_zip_total_counts_csb
export interface ELECTION_DOWNLOAD_ZIP_TOTAL_COUNTS_CSB_REQUEST_PARAMS {
  election_id: ElectionId;
  committee_session_id: CommitteeSessionId;
}
export type ELECTION_DOWNLOAD_ZIP_TOTAL_COUNTS_CSB_REQUEST_PATH =
  `/api/elections/${ElectionId}/committee_sessions/${CommitteeSessionId}/download_zip_total_counts_csb`;

// /api/elections/{election_id}/committee_sessions/{committee_session_id}/investigations
export interface COMMITTEE_SESSION_INVESTIGATIONS_REQUEST_PARAMS {
  election_id: ElectionId;
  committee_session_id: CommitteeSessionId;
}
export type COMMITTEE_SESSION_INVESTIGATIONS_REQUEST_PATH =
  `/api/elections/${ElectionId}/committee_sessions/${CommitteeSessionId}/investigations`;

// /api/elections/{election_id}/committee_sessions/{committee_session_id}/status
export interface COMMITTEE_SESSION_STATUS_CHANGE_REQUEST_PARAMS {
  election_id: ElectionId;
  committee_session_id: CommitteeSessionId;
}
export type COMMITTEE_SESSION_STATUS_CHANGE_REQUEST_PATH =
  `/api/elections/${ElectionId}/committee_sessions/${CommitteeSessionId}/status`;
export type COMMITTEE_SESSION_STATUS_CHANGE_REQUEST_BODY = CommitteeSessionStatusChangeRequest;

// /api/elections/{election_id}/data_entry/import
export interface ELECTION_DATA_ENTRY_IMPORT_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type ELECTION_DATA_ENTRY_IMPORT_REQUEST_PATH = `/api/elections/${ElectionId}/data_entry/import`;

// /api/elections/{election_id}/data_entry/import/validate
export interface ELECTION_DATA_ENTRY_IMPORT_VALIDATE_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type ELECTION_DATA_ENTRY_IMPORT_VALIDATE_REQUEST_PATH =
  `/api/elections/${ElectionId}/data_entry/import/validate`;

// /api/elections/{election_id}/dismiss_public_key_upload_reminder
export interface DISMISS_PUBLIC_KEY_UPLOAD_REMINDER_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type DISMISS_PUBLIC_KEY_UPLOAD_REMINDER_REQUEST_PATH =
  `/api/elections/${ElectionId}/dismiss_public_key_upload_reminder`;

// /api/elections/{election_id}/download_n_10_1
export interface ELECTION_DOWNLOAD_N_10_1_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type ELECTION_DOWNLOAD_N_10_1_REQUEST_PATH = `/api/elections/${ElectionId}/download_n_10_1`;

// /api/elections/{election_id}/download_n_10_1_inlegvel
export interface ELECTION_DOWNLOAD_N_10_1_INLEGVEL_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type ELECTION_DOWNLOAD_N_10_1_INLEGVEL_REQUEST_PATH = `/api/elections/${ElectionId}/download_n_10_1_inlegvel`;

// /api/elections/{election_id}/download_n_10_2
export interface ELECTION_DOWNLOAD_N_10_2_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type ELECTION_DOWNLOAD_N_10_2_REQUEST_PATH = `/api/elections/${ElectionId}/download_n_10_2`;

// /api/elections/{election_id}/download_na_14_1_versie1
export interface ELECTION_DOWNLOAD_NA_14_1_VERSIE1_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type ELECTION_DOWNLOAD_NA_14_1_VERSIE1_REQUEST_PATH = `/api/elections/${ElectionId}/download_na_14_1_versie1`;

// /api/elections/{election_id}/download_na_31_1_inlegvel
export interface ELECTION_DOWNLOAD_NA_31_1_INLEGVEL_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type ELECTION_DOWNLOAD_NA_31_1_INLEGVEL_REQUEST_PATH = `/api/elections/${ElectionId}/download_na_31_1_inlegvel`;

// /api/elections/{election_id}/download_na_31_2_bijlage1
export interface ELECTION_DOWNLOAD_NA_31_2_BIJLAGE1_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type ELECTION_DOWNLOAD_NA_31_2_BIJLAGE1_REQUEST_PATH = `/api/elections/${ElectionId}/download_na_31_2_bijlage1`;

// /api/elections/{election_id}/download_na_31_2_inlegvel
export interface ELECTION_DOWNLOAD_NA_31_2_INLEGVEL_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type ELECTION_DOWNLOAD_NA_31_2_INLEGVEL_REQUEST_PATH = `/api/elections/${ElectionId}/download_na_31_2_inlegvel`;

// /api/elections/{election_id}/polling_stations
export interface POLLING_STATION_LIST_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type POLLING_STATION_LIST_REQUEST_PATH = `/api/elections/${ElectionId}/polling_stations`;
export interface POLLING_STATION_CREATE_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type POLLING_STATION_CREATE_REQUEST_PATH = `/api/elections/${ElectionId}/polling_stations`;
export type POLLING_STATION_CREATE_REQUEST_BODY = PollingStationRequest;

// /api/elections/{election_id}/polling_stations/export
export interface POLLING_STATION_EXPORT_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type POLLING_STATION_EXPORT_REQUEST_PATH = `/api/elections/${ElectionId}/polling_stations/export`;

// /api/elections/{election_id}/polling_stations/import
export interface POLLING_STATION_IMPORT_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type POLLING_STATION_IMPORT_REQUEST_PATH = `/api/elections/${ElectionId}/polling_stations/import`;
export type POLLING_STATION_IMPORT_REQUEST_BODY = PollingStationsRequest;

// /api/elections/{election_id}/polling_stations/validate-import
export interface POLLING_STATION_VALIDATE_IMPORT_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type POLLING_STATION_VALIDATE_IMPORT_REQUEST_PATH =
  `/api/elections/${ElectionId}/polling_stations/validate-import`;
export type POLLING_STATION_VALIDATE_IMPORT_REQUEST_BODY = PollingStationFileRequest;

// /api/elections/{election_id}/polling_stations/{polling_station_id}
export interface POLLING_STATION_GET_REQUEST_PARAMS {
  election_id: ElectionId;
  polling_station_id: PollingStationId;
}
export type POLLING_STATION_GET_REQUEST_PATH = `/api/elections/${ElectionId}/polling_stations/${PollingStationId}`;
export interface POLLING_STATION_UPDATE_REQUEST_PARAMS {
  election_id: ElectionId;
  polling_station_id: PollingStationId;
}
export type POLLING_STATION_UPDATE_REQUEST_PATH = `/api/elections/${ElectionId}/polling_stations/${PollingStationId}`;
export type POLLING_STATION_UPDATE_REQUEST_BODY = PollingStationRequest;
export interface POLLING_STATION_DELETE_REQUEST_PARAMS {
  election_id: ElectionId;
  polling_station_id: PollingStationId;
}
export type POLLING_STATION_DELETE_REQUEST_PATH = `/api/elections/${ElectionId}/polling_stations/${PollingStationId}`;

// /api/elections/{election_id}/status
export interface ELECTION_STATUS_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type ELECTION_STATUS_REQUEST_PATH = `/api/elections/${ElectionId}/status`;

// /api/elections/{election_id}/sub_committee_certificates
export interface SUB_COMMITTEE_CERTIFICATES_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type SUB_COMMITTEE_CERTIFICATES_REQUEST_PATH = `/api/elections/${ElectionId}/sub_committee_certificates`;
export interface SUB_COMMITTEE_CERTIFICATE_ADD_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type SUB_COMMITTEE_CERTIFICATE_ADD_REQUEST_PATH = `/api/elections/${ElectionId}/sub_committee_certificates`;
export type SUB_COMMITTEE_CERTIFICATE_ADD_REQUEST_BODY = AddSubCommitteeCertificateRequest;

// /api/elections/{election_id}/sub_committees/{sub_committee_id}/certificates/{public_key_fingerprint}
export interface SUB_COMMITTEE_CERTIFICATE_DELETE_REQUEST_PARAMS {
  election_id: ElectionId;
  sub_committee_id: SubCommitteeId;
  public_key_fingerprint: string;
}
export type SUB_COMMITTEE_CERTIFICATE_DELETE_REQUEST_PATH =
  `/api/elections/${ElectionId}/sub_committees/${SubCommitteeId}/certificates/${string}`;

// /api/elections/{election_id}/voters
export interface ELECTION_NUMBER_OF_VOTERS_CHANGE_REQUEST_PARAMS {
  election_id: ElectionId;
}
export type ELECTION_NUMBER_OF_VOTERS_CHANGE_REQUEST_PATH = `/api/elections/${ElectionId}/voters`;
export type ELECTION_NUMBER_OF_VOTERS_CHANGE_REQUEST_BODY = ElectionNumberOfVotersChangeRequest;

// /api/generate_test_election
export type GENERATE_ELECTION_HANDLER_REQUEST_PARAMS = Record<string, never>;
export type GENERATE_ELECTION_HANDLER_REQUEST_PATH = `/api/generate_test_election`;
export type GENERATE_ELECTION_HANDLER_REQUEST_BODY = GenerateElectionArgs;

// /api/initialise/admin-exists
export type ADMIN_EXISTS_REQUEST_PARAMS = Record<string, never>;
export type ADMIN_EXISTS_REQUEST_PATH = `/api/initialise/admin-exists`;

// /api/initialise/first-admin
export type CREATE_FIRST_ADMIN_REQUEST_PARAMS = Record<string, never>;
export type CREATE_FIRST_ADMIN_REQUEST_PATH = `/api/initialise/first-admin`;
export type CREATE_FIRST_ADMIN_REQUEST_BODY = CreateFirstAdminRequest;

// /api/initialised
export type INITIALISED_REQUEST_PARAMS = Record<string, never>;
export type INITIALISED_REQUEST_PATH = `/api/initialised`;

// /api/log
export interface AUDIT_LOG_LIST_REQUEST_PARAMS {
  page?: number;
  per_page?: number;
  level?: string[];
  event?: string[];
  user?: number[];
  since?: number;
}
export type AUDIT_LOG_LIST_REQUEST_PATH = `/api/log`;

// /api/log-users
export type AUDIT_LOG_LIST_USERS_REQUEST_PARAMS = Record<string, never>;
export type AUDIT_LOG_LIST_USERS_REQUEST_PATH = `/api/log-users`;

// /api/login
export type LOGIN_REQUEST_PARAMS = Record<string, never>;
export type LOGIN_REQUEST_PATH = `/api/login`;
export type LOGIN_REQUEST_BODY = Credentials;

// /api/logout
export type LOGOUT_REQUEST_PARAMS = Record<string, never>;
export type LOGOUT_REQUEST_PATH = `/api/logout`;

// /api/polling_stations/{polling_station_id}/investigation
export interface POLLING_STATION_INVESTIGATION_UPDATE_REQUEST_PARAMS {
  polling_station_id: PollingStationId;
}
export type POLLING_STATION_INVESTIGATION_UPDATE_REQUEST_PATH =
  `/api/polling_stations/${PollingStationId}/investigation`;
export type POLLING_STATION_INVESTIGATION_UPDATE_REQUEST_BODY = PollingStationInvestigationUpdateRequest;
export interface POLLING_STATION_INVESTIGATION_CREATE_REQUEST_PARAMS {
  polling_station_id: PollingStationId;
}
export type POLLING_STATION_INVESTIGATION_CREATE_REQUEST_PATH =
  `/api/polling_stations/${PollingStationId}/investigation`;
export type POLLING_STATION_INVESTIGATION_CREATE_REQUEST_BODY = PollingStationInvestigationCreateRequest;
export interface POLLING_STATION_INVESTIGATION_DELETE_REQUEST_PARAMS {
  polling_station_id: PollingStationId;
}
export type POLLING_STATION_INVESTIGATION_DELETE_REQUEST_PATH =
  `/api/polling_stations/${PollingStationId}/investigation`;

// /api/polling_stations/{polling_station_id}/investigation/conclude
export interface POLLING_STATION_INVESTIGATION_CONCLUDE_REQUEST_PARAMS {
  polling_station_id: PollingStationId;
}
export type POLLING_STATION_INVESTIGATION_CONCLUDE_REQUEST_PATH =
  `/api/polling_stations/${PollingStationId}/investigation/conclude`;
export type POLLING_STATION_INVESTIGATION_CONCLUDE_REQUEST_BODY = PollingStationInvestigationConcludeRequest;

// /api/polling_stations/{polling_station_id}/investigation/download_corrigendum_pdf
export interface POLLING_STATION_INVESTIGATION_DOWNLOAD_CORRIGENDUM_PDF_REQUEST_PARAMS {
  polling_station_id: PollingStationId;
}
export type POLLING_STATION_INVESTIGATION_DOWNLOAD_CORRIGENDUM_PDF_REQUEST_PATH =
  `/api/polling_stations/${PollingStationId}/investigation/download_corrigendum_pdf`;

// /api/users
export type USER_LIST_REQUEST_PARAMS = Record<string, never>;
export type USER_LIST_REQUEST_PATH = `/api/users`;
export type USER_CREATE_REQUEST_PARAMS = Record<string, never>;
export type USER_CREATE_REQUEST_PATH = `/api/users`;
export type USER_CREATE_REQUEST_BODY = CreateUserRequest;

// /api/users/{user_id}
export interface USER_GET_REQUEST_PARAMS {
  user_id: UserId;
}
export type USER_GET_REQUEST_PATH = `/api/users/${UserId}`;
export interface USER_UPDATE_REQUEST_PARAMS {
  user_id: UserId;
}
export type USER_UPDATE_REQUEST_PATH = `/api/users/${UserId}`;
export type USER_UPDATE_REQUEST_BODY = UpdateUserRequest;
export interface USER_DELETE_REQUEST_PARAMS {
  user_id: UserId;
}
export type USER_DELETE_REQUEST_PATH = `/api/users/${UserId}`;

/** TYPES **/

/**
 * Information about the report ("Over het proces-verbaal")
 */
export interface AboutReport {
  /** Whether the extra page "controles en correcties" is inserted in the report
("Is voorin het proces-verbaal de extra pagina controles en correcties ingevoegd?") */
  checks_and_corrections_present: ChecksAndCorrectionsPresent | null;
  /** Whether a corrigendum accompanies the report
("Is er een corrigendum bij het papieren proces-verbaal aanwezig?") */
  corrigendum_present: CorrigendumPresent | null;
}

export interface AbsoluteMajorityDrawingLots {
  /** The list where the reassigned residual seat will go to */
  assign_to: PGNumber;
  /** The list options where the residual seat should come from */
  options: PGNumber[];
}

export interface AbsoluteMajorityReassignedSeat {
  drawing_lots?: ListDrawingLotsVariant;
  list_assigned_seat: PGNumber;
  list_retracted_seat: PGNumber;
}

export interface AccountUpdateRequest {
  fullname?: string;
  password: string;
  username: string;
}

/**
 * Request to add a sub committee certificate
 */
export interface AddSubCommitteeCertificateRequest {
  data: string;
}

/**
 * The certificate that was added, with the sub committee it was added to
 */
export interface AddSubCommitteeCertificateResponse {
  authority_name: string;
  certificate: Certificate;
  expired: boolean;
  sub_committee_id: SubCommitteeId;
}

export type ApportionmentState =
  | { type: "Uninitialised" }
  | { deceased_candidates: DeceasedCandidate[]; type: "RegisteringDeceasedCandidates" }
  | {
      candidates_drawn: CandidateDrawn[];
      deceased_candidates: DeceasedCandidate[];
      drawing_lots_required: DrawingLotsRequired;
      lists_drawn: ListDrawn[];
      type: "DrawingLots";
    }
  | {
      candidates_drawn: CandidateDrawn[];
      deceased_candidates: DeceasedCandidate[];
      lists_drawn: ListDrawn[];
      type: "Finalised";
    };

export const apportionmentWarningValues = ["AbsoluteMajorityAndListExhaustion", "NotAllSeatsAssigned"] as const;
export type ApportionmentWarning = (typeof apportionmentWarningValues)[number];

export const auditEventLevelValues = ["info", "success", "warning", "error"] as const;
export type AuditEventLevel = (typeof auditEventLevelValues)[number];

export const auditEventTypeValues = [
  "UserLoggedIn",
  "UserLoginFailed",
  "UserLoggedOut",
  "UserAccountUpdated",
  "UserSessionExtended",
  "UserCreated",
  "UserUpdated",
  "UserDeleted",
  "ElectionCreated",
  "ElectionUpdated",
  "PublicKeyUploadReminderDismissed",
  "CommitteeSessionCreated",
  "CommitteeSessionDeleted",
  "CommitteeSessionUpdated",
  "FileCreated",
  "FileDeleted",
  "ApportionmentProcessed",
  "ApportionmentStateUpdated",
  "InvestigationCreated",
  "InvestigationConcluded",
  "InvestigationUpdated",
  "InvestigationDeleted",
  "PollingStationCreated",
  "PollingStationUpdated",
  "PollingStationDeleted",
  "PollingStationsImported",
  "PollingStationsExported",
  "DataEntryStarted",
  "DataEntrySaved",
  "DataEntryImported",
  "DataEntryResumed",
  "DataEntryDeleted",
  "DataEntryDiscarded",
  "DataEntryReset",
  "DataEntryFinalised",
  "DataEntryDiscardedFirst",
  "DataEntryReturnedFirst",
  "DataEntryKeptFirst",
  "DataEntryKeptSecond",
  "DataEntryKeptFirstReturnedSecond",
  "DataEntryKeptSecondReturnedFirst",
  "DataEntryDiscardedBoth",
  "AirGapViolationDetected",
  "AirGapViolationResolved",
  "ApplicationStarted",
  "DatabaseBackupCreated",
  "SigningKeypairCreated",
  "SubCommitteeCertificateAdded",
  "SubCommitteeCertificateDeleted",
  "ApiError",
  "ApiWarning",
  "UnknownEvent",
] as const;
export type AuditEventType = (typeof auditEventTypeValues)[number];

export interface AuditLogEvent {
  event: unknown;
  event_level: AuditEventLevel;
  event_name: AuditEventType;
  id: AuditLogEventId;
  ip: string;
  message?: string;
  time: string;
  user_fullname?: string;
  user_id?: UserId;
  user_role?: Role;
  username?: string;
}

export type AuditLogEventId = number;

export interface AuditLogListResponse {
  events: AuditLogEvent[];
  page: number;
  pages: number;
  per_page: number;
}

export interface AuditLogUser {
  fullname: string;
  id: number;
  role: Role;
  username: string;
}

export interface BackupResponse {
  created_at: string;
  filename: string;
}

/**
 * Polling station base entity, linked to an election but
 * independent of the committee session or data entry.
 */
export interface BasePollingStation {
  address: string;
  id: PollingStationId;
  locality: string;
  name: string;
  number: u32;
  number_of_voters?: number;
  polling_station_type?: PollingStationType;
  postal_code: string;
}

export interface CSBDataEntryImportRequest {
  data: string;
  hash: string[];
}

export interface CSBDataEntryImportResponse {
  election_date: string;
  election_name: string;
  sub_committee: SubCommitteeFirstSession;
}

export interface CSBDataEntryImportValidateRequest {
  data: string;
  hash?: string[];
}

export interface CSBDataEntryImportValidateResponse {
  election_date: string;
  election_name: string;
  hash: RedactedEmlHash;
  sub_committee: SubCommitteeFirstSession;
}

export interface CSBElectionCreationRequest {
  candidate_data: string;
  candidate_hash: string[];
  election_data: string;
  election_hash: string[];
}

export interface CSBElectionCreationValidateRequest {
  candidate_data?: string;
  candidate_hash?: string[];
  election_data: string;
  election_hash?: string[];
}

export interface CSBElectionDefinitionValidateResponse {
  election: NewElection;
  hash: RedactedEmlHash;
}

/**
 * CSOFirstSessionResults, following the fields in Model Na 31-2 Bijlage 1.
 *
 * See "Model Na 31-2. Proces-verbaal van een gemeentelijk stembureau/stembureau voor het openbaar
 * lichaam in een gemeente/openbaar lichaam waar een centrale stemopneming wordt verricht,
 * Bijlage 1: Verslagen van tellingen van stembureaus" from
 * [Kiesraad](https://www.kiesraad.nl/documenten/2025/11/27/na-31-2-pv-gsb-cso).
 */
export interface CSOFirstSessionResults {
  /** Counting Differences Polling Station ("B1-2 Verschillen met telresultaten van het stembureau") */
  counting_differences_polling_station: CountingDifferencesPollingStation;
  /** Differences counts ("3. Verschil tussen het aantal toegelaten kiezers en het aantal getelde stembiljetten") */
  differences_counts: DifferencesCounts;
  /** Extra investigation ("B1-1 Extra onderzoek") */
  extra_investigation: ExtraInvestigation;
  /** Vote counts per list and candidate (5. "Aantal stemmen per lijst en kandidaat") */
  political_group_votes: PoliticalGroupCandidateVotes[];
  /** Voters counts ("1. Aantal toegelaten kiezers") */
  voters_counts: VotersCounts;
  /** Votes counts ("2. Aantal getelde stembiljetten") */
  votes_counts: VotesCounts;
}

/**
 * Polling stations where results were investigated by the GSB,
 * as vectors of polling station numbers
 */
export interface CSOInvestigations {
  /** Admitted voters were recounted
("Toegelaten kiezers opnieuw vastgesteld?") */
  admitted_voters_recounted: number[];
  /** Ballots were (partially) recounted
("Stembiljetten (deels) herteld?") */
  ballots_recounted: number[];
  /** Investigated for other reasons than unexplained difference
("Onderzocht vanwege andere reden dan onverklaard verschil?") */
  investigated_other_reason: number[];
}

/**
 * Candidate
 */
export interface Candidate {
  country_code?: string;
  first_name?: string;
  gender?: CandidateGender;
  initials: string;
  last_name: string;
  last_name_prefix?: string;
  locality: string;
  number: number;
}

export interface CandidateDrawingLotsVariant {
  /** The list the candidate needs to be drawn from */
  list: PGNumber;
  /** The number of votes, equal for these candidates */
  number_of_votes: number;
  /** The candidates that lots are drawn for */
  options: CandidateNumber[];
  /** The seat numbers that the candidates can be drawn for */
  seat_numbers: number[];
  /** The total number of seats for the list */
  total_seats: number;
}

/**
 * The candidate that has been drawn plus information to assert the correct drawing
 */
export interface CandidateDrawn {
  /** The candidate that the lot was drawn for */
  drawn: CandidateNumber;
  /** The type and information for drawing lots */
  variant: CandidateDrawingLotsVariant;
}

/**
 * Candidate gender
 */
export const candidateGenderValues = ["Male", "Female", "X"] as const;
export type CandidateGender = (typeof candidateGenderValues)[number];

export interface CandidateNomination {
  chosen_candidates: ChosenCandidate[];
  list_candidate_nomination: ListCandidateNomination[];
  preference_threshold: PreferenceThreshold;
}

export type CandidateNumber = number;

export interface CandidateVotes {
  number: number;
  votes: number;
}

export interface Certificate {
  common_name: string;
  election_identifier: string;
  not_after: string;
  not_before: string;
  organizational_unit: string;
  public_key: string;
  public_key_fingerprint: string;
  signature_algorithm: string;
}

export interface CertificateDetailsResponse {
  common_name: string;
  election_identifier: string;
  not_after: string;
  not_before: string;
  organizational_unit: string;
  signature_algorithm: string;
}

/**
 * Checks and corrections ("Controles en correcties")
 */
export interface ChecksAndCorrections {
  /** Whether investigation at the request of the central electoral committee
has led to corrected results
("Op verzoek van het centraal stembureau: Zijn er gecorrigeerde telresultaten?") */
  corrected_results_csb_request: YesNo;
  /** Whether the investigation on its own initiative has led to corrected results
("Op eigen initiatief van het gemeentelijk stembureau: Zijn er gecorrigeerde telresultaten?") */
  corrected_results_own_initiative: YesNo;
  /** Why the GSB investigated the counting results on its own initiative
("Op eigen initiatief van het gemeentelijk stembureau: Waarom heeft het gemeentelijk stembureau
 de telresultaten onderzocht?") */
  reason_investigation_own_initiative: ReasonInvestigationOwnInitiative;
}

/**
 * Whether the extra page "controles en correcties" is inserted in the report
 */
export const checksAndCorrectionsPresentValues = ["PagePresent", "PageMissing"] as const;
export type ChecksAndCorrectionsPresent = (typeof checksAndCorrectionsPresentValues)[number];

/**
 * Chosen candidate
 */
export interface ChosenCandidate {
  country_code?: string;
  first_name?: string;
  gender?: CandidateGender;
  initials: string;
  last_name: string;
  last_name_prefix?: string;
  list_name: string;
  list_number: PGNumber;
  locality: string;
  number: number;
}

/**
 * Response structure for getting data entry results
 */
export interface ClaimDataEntryResponse {
  client_state: unknown;
  /** Fields for which a warning should be shown that a difference should be corrected */
  correction_warnings?: string[];
  data: Results;
  /** Whether the typist is correcting an entry that was completed before */
  is_correction: boolean;
  previous_results?: CommonPollingStationResults;
  source: DataEntrySource;
  status: DataEntryStatusName;
  validation_results: ValidationResults;
}

/**
 * Committee category
 */
export const committeeCategoryValues = ["GSB", "CSB"] as const;
export type CommitteeCategory = (typeof committeeCategoryValues)[number];

/**
 * Which district this committee is contained within.
 */
export type CommitteeDistrict = { district: "None" } | { district: "All" } | (RegionDetails & { district: "Specific" });

/**
 * Committee session
 */
export interface CommitteeSession {
  election_id: ElectionId;
  id: CommitteeSessionId;
  location: string;
  number: number;
  start_date_time?: string;
  status: CommitteeSessionStatus;
}

export type CommitteeSessionId = number;

/**
 * Committee session status
 */
export const committeeSessionStatusValues = ["created", "in_preparation", "data_entry", "paused", "completed"] as const;
export type CommitteeSessionStatus = (typeof committeeSessionStatusValues)[number];

/**
 * Committee session status change request
 */
export interface CommitteeSessionStatusChangeRequest {
  status: CommitteeSessionStatus;
}

/**
 * Committee session update request
 */
export interface CommitteeSessionUpdateRequest {
  location: string;
  start_date: string;
  start_time: string;
}

/**
 * Committee specific totals, i.e. specific for GSB or CSB.
 */
export type CommitteeSpecificTotals =
  | (GSBTotals & { committee: "GSB" })
  | {
      committee: "CSB";
      /** The number of voters ("Kiesgerechtigden") */
      number_of_voters: number;
    };

/**
 * CommonPollingStationResults contains the common fields for polling station results,
 */
export interface CommonPollingStationResults {
  /** Differences counts ("Verschil tussen het aantal toegelaten kiezers en het aantal getelde stembiljetten") */
  differences_counts: DifferencesCounts;
  /** Vote counts per list and candidate ("Aantal stemmen per lijst en kandidaat") */
  political_group_votes: PoliticalGroupCandidateVotes[];
  /** Voters counts ("Aantal toegelaten kiezers") */
  voters_counts: VotersCounts;
  /** Votes counts ("Aantal getelde stembiljetten") */
  votes_counts: VotesCounts;
}

/**
 * Whether a corrigendum accompanies the report
 */
export const corrigendumPresentValues = ["TwoDocuments", "OneDocument"] as const;
export type CorrigendumPresent = (typeof corrigendumPresentValues)[number];

/**
 * Counting Differences Polling Station,
 * part of the results ("B1-2 Verschillen met telresultaten van het stembureau")
 */
export interface CountingDifferencesPollingStation {
  /** Whether there was a difference between the total votes per list as determined by the polling station and by the typist
("Is er een verschil tussen het totaal aantal getelde stembiljetten per lijst zoals eerder vastgesteld door het stembureau en zoals door u geteld op het gemeentelijk stembureau?") */
  difference_ballots_per_list: YesNo;
  /** Whether the total of admitted voters (D) and the total of votes counted (H) are equal, or the difference was completely accounted for
("Is in de telresultaten van het stembureau het aantal toegelaten kiezers (D) en het totaal aantal getelde stemmen (H) gelijk OF is er een verschil en is dit verschil volledig verklaard?") */
  difference_ballots_voters_completely_accounted_for: YesNo;
}

export interface CreateFirstAdminRequest {
  fullname: string;
  temp_password: string;
  username: string;
}

export interface CreateUserRequest {
  fullname?: string;
  role: Role;
  temp_password: string;
  username: string;
}

export interface Credentials {
  password: string;
  username: string;
}

/**
 * DSOFirstSessionResults, following the fields in Model N 10-1
 *
 * See: Model N 10-1 (Proces-verbaal van een stembureau) from
 * [kiesraad](https://www.kiesraad.nl/documenten/2025/11/27/n-10-1-pv-sb-dso)
 */
export interface DSOFirstSessionResults {
  /** About report ("Over het proces-verbaal") */
  about_report: AboutReport;
  /** Checks and corrections ("Controles en correcties") */
  checks_and_corrections: ChecksAndCorrections;
  /** Differences counts ("3. Verschil tussen het aantal toegelaten kiezers en het aantal getelde stembiljetten") */
  differences_counts: DifferencesCounts;
  /** Vote counts per list and candidate (5. "Aantal stemmen per lijst en kandidaat") */
  political_group_votes: PoliticalGroupCandidateVotes[];
  /** Voters counts ("1. Aantal toegelaten kiezers") */
  voters_counts: VotersCounts;
  /** Votes counts ("2. Aantal getelde stembiljetten") */
  votes_counts: VotesCounts;
}

/**
 * Polling stations where results were investigated by the GSB,
 * as vectors of polling station numbers
 */
export interface DSOInvestigations {
  /** Results were corrected
("Uitslag gecorrigeerd?") */
  corrected_results: number[];
  /** Investigated because of a (suspected) other error
("Onderzocht vanwege (het vermoeden van) een andere fout?") */
  other_error: number[];
  /** Investigated because of an unaccounted-for difference
("Onderzocht vanwege een onverklaard verschil?") */
  unaccounted_difference: number[];
}

/**
 * Request structure for saving data entry
 */
export interface DataEntry {
  /** Client state for the data entry (arbitrary JSON) */
  client_state: unknown;
  /** Data entry for a polling station */
  data: Results;
  /** Data entry progress between 0 and 100 */
  progress: number;
}

export interface DataEntryGetDifferencesResponse {
  first_entry: Results;
  first_entry_has_errors: boolean;
  first_entry_origin: DataEntryOrigin;
  second_entry: Results;
  second_entry_has_errors: boolean;
  second_entry_user_id: UserId;
  source: DataEntrySource;
}

export interface DataEntryGetResponse {
  data: Results;
  source: DataEntrySource;
  status: DataEntryStatusName;
  user_id?: UserId;
  validation_results: ValidationResults;
}

export type DataEntryId = number;

export type DataEntryOrigin = { type: "Import" } | { type: "Typist"; user_id: UserId };

export type DataEntrySource =
  | (PollingStationForSession & { type: "PollingStation" })
  | (SubCommitteeFirstSession & { type: "SubCommittee" });

export type DataEntrySourceNumber = { number: u32; type: "PollingStation" } | { number: u32; type: "SubCommittee" };

export const dataEntryStatusNameValues = [
  "empty",
  "first_entry_in_progress",
  "first_entry_has_errors",
  "first_entry_finalised",
  "second_entry_in_progress",
  "entries_different",
  "first_entry_correction",
  "second_entry_correction",
  "definitive",
] as const;
export type DataEntryStatusName = (typeof dataEntryStatusNameValues)[number];

export interface DataEntryStatusResponse {
  status: DataEntryStatusName;
}

export interface DeceasedCandidate {
  candidate_number: CandidateNumber;
  pg_number: PGNumber;
}

/**
 * Compare votes cast admitted voters, part of the differences counts.
 */
export interface DifferenceCountsCompareVotesCastAdmittedVoters {
  /** Whether total of admitted voters and total of votes cast match.
("D en H zijn gelijk") */
  admitted_voters_equal_votes_cast: boolean;
  /** Whether total of admitted voters is greater than total of votes cast match.
("H is groter dan D (meer uitgebrachte stemmen dan toegelaten kiezers)") */
  votes_cast_greater_than_admitted_voters: boolean;
  /** Whether total of admitted voters is less than total of votes cast match.
("H is kleiner dan D (minder uitgebrachte stemmen dan toegelaten kiezers)") */
  votes_cast_smaller_than_admitted_voters: boolean;
}

/**
 * Differences counts, part of the results.
 * (B1-3.3 "Verschillen tussen aantal kiezers en uitgebrachte stemmen")
 */
export interface DifferencesCounts {
  /** Whether total of admitted voters and total of votes cast match.
(B1-3.3.1 "Vergelijk D (totaal toegelaten kiezers) en H (totaal uitgebrachte stemmen)") */
  compare_votes_cast_admitted_voters: DifferenceCountsCompareVotesCastAdmittedVoters;
  /** Whether the difference between the total of admitted voters and total of votes cast is explained.
(B1-3.3.2 "Zijn er tijdens de stemming dingen opgeschreven die het bovenstaande verschil tussen D en H volledig verklaren?") */
  difference_completely_accounted_for: YesNo;
  /** Number of fewer counted ballots ("Aantal minder getelde stemmen (bereken: D min H)") */
  fewer_ballots_count: number;
  /** Number of more counted ballots ("Aantal méér getelde stemmen (bereken: H min D)") */
  more_ballots_count: number;
}

/**
 * Contains the totals of the differences, containing which polling stations had differences.
 */
export interface DifferencesTotals {
  fewer_ballots_count: SumCount;
  more_ballots_count: SumCount;
}

/**
 * Fraction with the integer part split out for display purposes
 */
export interface DisplayFraction {
  denominator: number;
  integer: number;
  numerator: number;
}

export type DrawingLotsRequired =
  | (ListDrawingLotsVariant & { type: "ListDrawingLotsRequired" })
  | (CandidateDrawingLotsVariant & { type: "CandidateDrawingLotsRequired" });

/**
 * Election without political groups.
 *
 * Note: an election within Abacus does not represent the entire election, but
 * rather a single committee (i.e. stembureau at the CSB, HSB or GSB level)
 * within the election.
 *
 * When access to the political groups and their candidates is required, use
 * [`ElectionWithPoliticalGroups`] instead. When creating a new election, use
 * [`NewElection`] instead.
 */
export interface Election {
  /** See [`ElectionWithPoliticalGroups::authority_id`] */
  authority_id: string;
  /** See [`ElectionWithPoliticalGroups::authority_name`] */
  authority_name: string;
  /** See [`ElectionWithPoliticalGroups::authority_region`] */
  authority_region: string;
  /** See [`ElectionWithPoliticalGroups::category`] */
  category: ElectionCategory;
  /** See [`ElectionWithPoliticalGroups::committee_category`] */
  committee_category: CommitteeCategory;
  /** See [`ElectionWithPoliticalGroups::counting_method`] */
  counting_method?: VoteCountingMethod;
  /** See [`ElectionWithPoliticalGroups::district`] */
  district: CommitteeDistrict;
  /** See [`ElectionWithPoliticalGroups::domain`] */
  domain?: ElectionDomain;
  /** See [`ElectionWithPoliticalGroups::election_date`] */
  election_date: string;
  /** See [`ElectionWithPoliticalGroups::election_id`] */
  election_id: string;
  /** See [`ElectionWithPoliticalGroups::id`] */
  id: ElectionId;
  /** See [`ElectionWithPoliticalGroups::location`] */
  location: string;
  /** See [`ElectionWithPoliticalGroups::name`] */
  name: string;
  /** See [`ElectionWithPoliticalGroups::nomination_date`] */
  nomination_date: string;
  /** See [`ElectionWithPoliticalGroups::number_of_seats`] */
  number_of_seats: number;
  /** See [`ElectionWithPoliticalGroups::number_of_voters`] */
  number_of_voters: number;
  /** See [`ElectionWithPoliticalGroups::official_name`] */
  official_name: string;
  /** See [`ElectionWithPoliticalGroups::sub_category`] */
  sub_category: ElectionSubCategory;
}

export interface ElectionApportionmentResponse {
  candidate_nomination: CandidateNomination;
  election_totals: ElectionTotals;
  seat_assignment: SeatAssignment;
  warnings: ApportionmentWarning[];
}

/**
 * Election category (limited for now)
 */
export const electionCategoryValues = ["Municipal", "Provincial", "WaterAuthority"] as const;
export type ElectionCategory = (typeof electionCategoryValues)[number];

export type ElectionCreationRequest =
  | (GSBElectionCreationRequest & { committee_category: "GSB" })
  | (CSBElectionCreationRequest & { committee_category: "CSB" });

export type ElectionCreationValidateRequest =
  | (GSBElectionCreationValidateRequest & { committee_category: "GSB" })
  | (CSBElectionCreationValidateRequest & { committee_category: "CSB" });

export type ElectionDefinitionValidateResponse =
  | (GSBElectionDefinitionValidateResponse & { committee_category: "GSB" })
  | (CSBElectionDefinitionValidateResponse & { committee_category: "CSB" });

/**
 * Election details response, including the election's candidate list (political groups),
 * its polling stations and its committee sessions and current committee session
 */
export interface ElectionDetailsResponse {
  committee_sessions: CommitteeSession[];
  current_committee_session: CommitteeSession;
  election: ElectionWithPoliticalGroups;
  investigations: PollingStationInvestigation[];
  polling_stations: PollingStation[];
  show_keypair_reminder?: KeypairReminder;
}

/**
 * Election domain (i.e. the entity at which the election takes place)
 */
export interface ElectionDomain {
  /** Identifier of the domain */
  id?: string;
  /** Name of the domain */
  name: string;
}

export type ElectionId = number;

/**
 * Election list response
 *
 * Also includes a list of the current committee session for each election.
 * Does not include the candidate list (political groups) to keep the response size small.
 */
export interface ElectionListResponse {
  committee_sessions: CommitteeSession[];
  elections: Election[];
}

/**
 * Election number of voters change request
 */
export interface ElectionNumberOfVotersChangeRequest {
  number_of_voters: number;
}

/**
 * Election data entry statuses response
 */
export interface ElectionStatusResponse {
  statuses: ElectionStatusResponseEntry[];
}

/**
 * Election data entry statuses response entry
 */
export interface ElectionStatusResponseEntry {
  /** Data entry id */
  data_entry_id: DataEntryId;
  /** Current data entry progress as a percentage (0 to 100) */
  data_entry_progress?: number;
  /** Whether the finalised first or second data entry has warnings */
  finalised_with_warnings?: boolean;
  /** Time when the data entry was finalised */
  finished_at?: string;
  /** First entry origin (import or typist user id) */
  first_entry_origin?: DataEntryOrigin;
  /** Second entry user id */
  second_entry_user_id?: number;
  /** Data entry source (polling station or subcommittee) */
  source: DataEntrySource;
  /** Data entry status */
  status: DataEntryStatusName;
  /** Time when the data entry was last updated */
  updated_at: string;
}

/**
 * Election sub category (limited for now)
 */
export const electionSubCategoryValues = ["AB1", "AB2", "GR1", "GR2", "PS1", "PS2"] as const;
export type ElectionSubCategory = (typeof electionSubCategoryValues)[number];

/**
 * Contains the totals of the election results, added up from the votes of all polling stations.
 */
export interface ElectionTotals {
  /** Totals specific to the committee (GSB or CSB) of the election */
  committee_specific: CommitteeSpecificTotals;
  /** The differences between voters and votes */
  differences_counts: DifferencesTotals;
  /** The total votes for each political group (and each candidate within) */
  political_group_votes: PoliticalGroupCandidateVotes[];
  /** The total number of voters */
  voters_counts: VotersCounts;
  /** The total number of votes */
  votes_counts: VotesCounts;
}

/**
 * Election with political groups.
 *
 * Note: an election within Abacus does not represent the entire election, but
 * rather a single committee (i.e. stembureau at the CSB, HSB or GSB level)
 * within the election.
 *
 * When you do not need access to political groups and their candidates, you
 * can use [`Election`] instead. When creating a new election, use
 * [`NewElection`] instead.
 */
export interface ElectionWithPoliticalGroups {
  /** Identifier of the authority/region that this committee is responsible for. */
  authority_id: string;
  /** Name of the authority. Note that most of the time this is the same as the
region name, but specifically for country wide elections the authority
name may also be "De Kiesraad" instead of the region name of "Nederland". */
  authority_name: string;
  /** The name of the region that the committee is responsible for. */
  authority_region: string;
  /** The category of the election, as defined by EML_NL election definition.
Examples include "Municipal" for municipal elections or "WaterAuthority"
for the water authority elections. */
  category: ElectionCategory;
  /** The category (e.g. CSB) of the committee that this struct represents */
  committee_category: CommitteeCategory;
  /** If this is a GSB committee, this is the counting method used for
vote tabulation. This field is not used for other committee types. */
  counting_method?: VoteCountingMethod;
  /** The district that this committee is responsible for. This will be None
for committees within elections that do not have districts. When an
election does have districts this will be All for committees that are
responsible for all districts, or Specific for committees that sit
within a specific district. */
  district: CommitteeDistrict;
  /** An election wide field: for elections that do not concern the entire
country this field contains the specific domain of that election. For
example for municipal elections this contains the municipality that the
election is for. Note that the election domain id is not always available,
even if a domain is present. For country wide elections this field is None. */
  domain?: ElectionDomain;
  /** The date of the election, as defined by the EML_NL election definition.
Note: this is the date that the election takes/took place, not necessarily
the date that the committee is in session. */
  election_date: string;
  /** The election identifier as defined in the EML_NL election definition */
  election_id: string;
  /** Identifier of the election within Abacus */
  id: ElectionId;
  /** The location of the committee.

For GSB committees this will be the same as the authority region, but
for HSBs and CSBs this may also be a specific town or city within the
authority region. */
  location: string;
  /** Name of the election, as formatted for display in Abacus. */
  name: string;
  /** The date when candidate nominations for this election are/were closed. */
  nomination_date: string;
  /** The number of seats that are to be elected for. For example, this is 150
for elections for the House of Representatives (Tweede Kamer). */
  number_of_seats: number;
  /** How many voters are registered for this election. */
  number_of_voters: number;
  /** Name of the election, as defined in the EML_NL election definition. */
  official_name: string;
  /** The political groups and their candidates that are registered for this
election. */
  political_groups: PoliticalGroup[];
  /** The sub-category of the election, as defined by the EML_NL election
definition. */
  sub_category: ElectionSubCategory;
}

/**
 * Error reference used to show the corresponding error message to the end-user
 */
export const errorReferenceValues = [
  "AirgapViolation",
  "AlreadyInitialised",
  "BackupAlreadyExists",
  "ApportionmentNotCompleted",
  "ApportionmentCommitteeSessionNotCompleted",
  "ApportionmentInvalidLotDrawing",
  "CertificateAlreadyAdded",
  "CertificateUnknownSubCommittee",
  "CertificateWrongElection",
  "CommitteeSessionPaused",
  "DatabaseError",
  "DataEntryAlreadyClaimed",
  "DataEntryAlreadyImported",
  "DataEntryAlreadyFinalised",
  "DataEntryCannotBeReset",
  "DataEntryGetNotAllowed",
  "DataEntryNotAllowed",
  "DataEntryValidationErrors",
  "ElectionMismatch",
  "EmlImportError",
  "EmlError",
  "EntryNotFound",
  "EntryNotUnique",
  "Forbidden",
  "InternalServerError",
  "InvalidApportionmentState",
  "InvalidCertificate",
  "InvalidCommitteeSessionStatus",
  "InvalidCountType",
  "InvalidData",
  "InvalidDistrict",
  "InvalidFullname",
  "InvalidHash",
  "InvalidJson",
  "InvalidPassword",
  "InvalidPoliticalGroup",
  "InvalidDataEntrySource",
  "InvalidSession",
  "InvalidStateTransition",
  "InvalidUsername",
  "InvalidUsernameOrPassword",
  "InvalidVoteCandidate",
  "InvalidVoteGroup",
  "InvestigationHasDataEntryOrResult",
  "InvestigationRequiresCorrectedResults",
  "LoginRateLimited",
  "NotInitialised",
  "OwnAccountCannotBeDeleted",
  "PasswordRejectionSameAsOld",
  "PasswordRejectionSameAsUsername",
  "PasswordRejectionTooShort",
  "PdfGenerationError",
  "PollingStationRepeated",
  "RequestPayloadTooLarge",
  "SignatureMissing",
  "SignatureUnknown",
  "SubCommitteeHasNoCertificates",
  "Unauthorized",
  "UnknownCommittee",
  "UsernameNotUnique",
  "UserNotFound",
  "ZipError",
] as const;
export type ErrorReference = (typeof errorReferenceValues)[number];

/**
 * Response structure for errors
 */
export interface ErrorResponse {
  error: string;
  fatal: boolean;
  reference: ErrorReference;
}

/**
 * Extra investigation, part of the results ("B1-1 Extra onderzoek")
 */
export interface ExtraInvestigation {
  /** Whether ballots were (partially) recounted following the extra investigation
("Zijn de stembiljetten naar aanleiding van het extra onderzoek (gedeeltelijk) herteld?") */
  ballots_recounted_extra_investigation: YesNo;
  /** Whether extra investigation was done
("Heeft het gemeentelijk stembureau extra onderzoek gedaan?") */
  extra_investigation_done: YesNo;
}

/**
 * Differences counts for GSB, part of the results.
 * (1.4 "Verschillen tussen aantal kiezers en uitgebrachte stemmen")
 */
export interface GSBDifferencesCounts {
  /** Number of fewer counted ballots ("Totaal aantal minder getelde stemmen") */
  fewer_ballots_count: number;
  /** Number of more counted ballots ("Totaal aantal méér getelde stemmen") */
  more_ballots_count: number;
}

export interface GSBElectionCreationRequest {
  candidate_data: string;
  candidate_hash: string[];
  counting_method: VoteCountingMethod;
  election_data: string;
  election_hash: string[];
  number_of_voters: number;
  polling_station_data?: string;
  polling_station_file_name?: string;
  selected_region?: RegionKey;
}

export interface GSBElectionCreationValidateRequest {
  candidate_data?: string;
  candidate_hash?: string[];
  counting_method?: VoteCountingMethod;
  election_data: string;
  election_hash?: string[];
  number_of_voters?: number;
  polling_station_data?: string;
  polling_station_file_name?: string;
  selected_region?: RegionKey;
}

export interface GSBElectionDefinitionValidateResponse {
  election: NewElection;
  gsb_list: RegionDetails[];
  hash: RedactedEmlHash;
  number_of_voters: number;
  polling_station_definition_matches_election?: boolean;
  polling_stations?: PollingStationRequest[];
}

/**
 * GSBResults, following the fields in Model Na 31-2.
 *
 * See "Model Na 31-2. Proces-verbaal van een gemeentelijk stembureau/stembureau voor het openbaar
 * lichaam in een gemeente/openbaar lichaam waar een centrale stemopneming wordt verricht" from
 * [Kiesraad](https://www.kiesraad.nl/documenten/2025/11/27/na-31-2-pv-gsb-cso).
 */
export interface GSBResults {
  /** Differences counts ("Verschil tussen het aantal toegelaten kiezers en het aantal getelde stembiljetten") */
  differences_counts: GSBDifferencesCounts;
  /** Number of voters ("Kiesgerechtigden") */
  number_of_voters: number;
  /** Vote counts per list and candidate ("Aantal stemmen per lijst en kandidaat") */
  political_group_votes: PoliticalGroupCandidateVotes[];
  /** Voters counts ("Aantal toegelaten kiezers") */
  voters_counts: VotersCounts;
  /** Votes counts ("Aantal getelde stembiljetten") */
  votes_counts: VotesCounts;
}

/**
 * GSB specific totals, depending on the vote counting method (CSO or DSO).
 */
export type GSBTotals =
  | (CSOInvestigations & { counting_method: "CSO" })
  | (DSOInvestigations & { counting_method: "DSO" });

/**
 * Abacus API and asset server
 */
export interface GenerateElectionArgs {
  candidate_distribution_slope: RandomRange;
  /** Number of candidates to create */
  candidates_per_group: RandomRange;
  /** GSB or CSB */
  committee_category: CommitteeCategory;
  /** CSO or DSO */
  counting_method?: VoteCountingMethod;
  /** Custom election name */
  custom_name?: string;
  /** Municipal, Provincial or WaterAuthority */
  election_category: ElectionCategory;
  /** Percentage of the first data entry to complete if data entry is included */
  first_data_entry: RandomRange;
  /** Generate multiple elections, each resulting in drawing lots */
  generate_drawing_lots: boolean;
  /** Generate multiple elections, each resulting in a different P 22-2 variant */
  generate_p22_2_variants: boolean;
  /** Amount of GSBs */
  gsbs: RandomRange;
  political_group_distribution_slope: RandomRange;
  /** Number of political groups to create */
  political_groups: RandomRange;
  /** Number of polling stations to create */
  polling_stations: RandomRange;
  /** Number of seats in the election */
  seats: RandomRange;
  /** Percentage of the completed first data entries that also get a second data entry */
  second_data_entry: RandomRange;
  /** Percentage of voters that voted (given we generate data entries) */
  turnout: RandomRange;
  /** Number of voters to create */
  voters: RandomRange;
  /** Include (part of) data entry for this election */
  with_data_entry: boolean;
}

export interface HighestAverageAssignedSeat {
  drawing_lots?: ListDrawingLotsVariant;
  list_assigned: PGNumber[];
  list_exhausted: PGNumber[];
  list_options: PGNumber[];
  selected_list_number: PGNumber;
  votes_per_seat: DisplayFraction;
}

export interface HighestAverageResidualSeatDrawingLots {
  list_averages: ListAverage[];
  max_average: DisplayFraction;
  options: PGNumber[];
  residual_seat_numbers: number[];
}

export interface InvestigationConcludedWithNewResults {
  findings: string;
  reason: string;
}

export interface InvestigationConcludedWithoutNewResults {
  findings: string;
  reason: string;
}

export interface InvestigationInProgress {
  reason: string;
}

/**
 * Investigation list response
 */
export interface InvestigationListResponse {
  investigations: PollingStationInvestigation[];
}

export type InvestigationStatus =
  | { state: InvestigationInProgress; status: "InProgress" }
  | { state: InvestigationConcludedWithoutNewResults; status: "ConcludedWithoutNewResults" }
  | { state: InvestigationConcludedWithNewResults; status: "ConcludedWithNewResults" };

export const keypairReminderValues = ["Dismissable", "NonDismissable"] as const;
export type KeypairReminder = (typeof keypairReminderValues)[number];

export interface LargestRemainderAssignedSeat {
  drawing_lots?: ListDrawingLotsVariant;
  list_assigned: PGNumber[];
  list_options: PGNumber[];
  remainder_votes: DisplayFraction;
  selected_list_number: PGNumber;
}

export interface LargestRemainderResidualSeatDrawingLots {
  list_remainders: ListRemainder[];
  max_remainder: DisplayFraction;
  options: PGNumber[];
  residual_seat_numbers: number[];
}

export interface ListAverage {
  average: DisplayFraction;
  pg_number: PGNumber;
}

export interface ListCandidateNomination {
  list_name: string;
  list_number: PGNumber;
  list_seats: number;
  other_candidate_nomination: CandidateVotes[];
  preferential_candidate_nomination: CandidateVotes[];
  updated_candidate_ranking: Candidate[];
}

export type ListDrawingLotsVariant =
  | (HighestAverageResidualSeatDrawingLots & { variant: "HighestAverageResidualSeat" })
  | (LargestRemainderResidualSeatDrawingLots & { variant: "LargestRemainderResidualSeat" })
  | (AbsoluteMajorityDrawingLots & { variant: "AbsoluteMajorityHighestAverage" })
  | (AbsoluteMajorityDrawingLots & { variant: "AbsoluteMajorityLargestRemainder" });

/**
 * The list that has been drawn plus information to assert the correct drawing
 */
export interface ListDrawn {
  /** The list that the lot was drawn for */
  drawn: PGNumber;
  /** The type of seat assignment or retraction that lots need to be drawn for */
  variant: ListDrawingLotsVariant;
}

export interface ListExhaustionRemovedSeat {
  full_seat: boolean;
  list_retracted_seat: PGNumber;
}

export interface ListRemainder {
  pg_number: PGNumber;
  remainder: DisplayFraction;
}

export interface ListSeatAssignment {
  full_seats: number;
  list_number: PGNumber;
  meets_remainder_threshold: boolean;
  remainder_votes: DisplayFraction;
  residual_seats: number;
  total_seats: number;
  votes_cast: number;
}

export interface ListStanding {
  full_seats: number;
  list_number: PGNumber;
  meets_remainder_threshold: boolean;
  next_votes_per_seat: DisplayFraction;
  remainder_votes: DisplayFraction;
  residual_seats: number;
  votes_cast: number;
}

export interface LoginResponse {
  fullname?: string;
  needs_password_change: boolean;
  role: Role;
  user_id: UserId;
  username: string;
}

/**
 * Struct for creating a new election in Abacus.
 *
 * This struct does not contain the internal Abacus election id, as that is
 * generated by Abacus when creating a new election.
 *
 * Note: an election within Abacus does not represent the entire election, but
 * rather a single committee (i.e. stembureau at the CSB, HSB or GSB level)
 * within the election.
 *
 * Please take a look at [`ElectionWithPoliticalGroups`] for the full election
 * representation, or [`Election`] for the election representation without
 * political groups and their candidates.
 */
export interface NewElection {
  /** See [`ElectionWithPoliticalGroups::authority_id`] */
  authority_id: string;
  /** See [`ElectionWithPoliticalGroups::authority_name`] */
  authority_name: string;
  /** See [`ElectionWithPoliticalGroups::authority_region`] */
  authority_region: string;
  /** See [`ElectionWithPoliticalGroups::category`] */
  category: ElectionCategory;
  /** See [`ElectionWithPoliticalGroups::committee_category`] */
  committee_category: CommitteeCategory;
  /** See [`ElectionWithPoliticalGroups::counting_method`] */
  counting_method?: VoteCountingMethod;
  /** See [`ElectionWithPoliticalGroups::district`] */
  district: CommitteeDistrict;
  /** See [`ElectionWithPoliticalGroups::domain`] */
  domain?: ElectionDomain;
  /** See [`ElectionWithPoliticalGroups::election_date`] */
  election_date: string;
  /** See [`ElectionWithPoliticalGroups::election_id`] */
  election_id: string;
  /** See [`ElectionWithPoliticalGroups::location`] */
  location: string;
  /** See [`ElectionWithPoliticalGroups::name`] */
  name: string;
  /** See [`ElectionWithPoliticalGroups::nomination_date`] */
  nomination_date: string;
  /** See [`ElectionWithPoliticalGroups::number_of_seats`] */
  number_of_seats: number;
  /** See [`ElectionWithPoliticalGroups::number_of_voters`] */
  number_of_voters: number;
  /** See [`ElectionWithPoliticalGroups::official_name`] */
  official_name: string;
  /** See [`ElectionWithPoliticalGroups::political_groups`] */
  political_groups: RegisteredPoliticalGroup[];
  /** See [`ElectionWithPoliticalGroups::sub_category`] */
  sub_category: ElectionSubCategory;
}

/**
 * NextSessionResults, following the fields in Model Na 14-2 Bijlage 1/Na 14-1 versie 2.
 *
 * See "Model Na 14-2. Corrigendum bij het proces-verbaal van een gemeentelijk stembureau/
 * stembureau voor het openbaar lichaam, Bijlage 1: uitkomsten per stembureau" from
 * <https://www.kiesraad.nl/documenten/2025/11/27/na-14-2-corrigendum-gsb-inclusief-bijlage-voor-cso)>.
 * See also "Model Na 14-1 (Corrigendum bij het proces-verbaal van een stembureau)"
 * <https://www.kiesraad.nl/documenten/2025/11/27/model-na-14-1>.
 */
export interface NextSessionResults {
  /** Differences counts ("Verschil tussen het aantal toegelaten kiezers en het aantal getelde stembiljetten") */
  differences_counts: DifferencesCounts;
  /** Vote counts per list and candidate ("Aantal stemmen per lijst en kandidaat") */
  political_group_votes: PoliticalGroupCandidateVotes[];
  /** Voters counts ("Aantal toegelaten kiezers") */
  voters_counts: VotersCounts;
  /** Votes counts ("Aantal getelde stembiljetten") */
  votes_counts: VotesCounts;
}

export type PGNumber = number;

/**
 * Political group and its candidates (with name as used for display purposes)
 */
export interface PoliticalGroup {
  /** List of candidates of the political group */
  candidates: Candidate[];
  /** Political group name as used for display purposes (with 'Blanco' in case of empty registered name) */
  name: string;
  /** Political group number */
  number: number;
}

export interface PoliticalGroupCandidateVotes {
  candidate_votes: CandidateVotes[];
  number: number;
  total: number;
}

export interface PoliticalGroupTotalVotes {
  number: number;
  total: number;
}

/**
 * Polling station linked to an election, committee session and (previous) data entry.
 */
export interface PollingStation {
  address: string;
  committee_session_id: CommitteeSessionId;
  data_entry_id?: DataEntryId;
  election_id: ElectionId;
  id: PollingStationId;
  locality: string;
  name: string;
  number: number;
  number_of_voters?: number;
  polling_station_type?: PollingStationType;
  postal_code: string;
  prev_data_entry_id?: DataEntryId;
}

export interface PollingStationFileRequest {
  data: string;
}

/**
 * Polling station in a first committee session.
 * No investigations, no previous data entries.
 */
export type PollingStationFirstSession = BasePollingStation & {
  committee_session_id: CommitteeSessionId;
  data_entry_id: DataEntryId;
};

/**
 * A single polling station for either a first or next committee session
 */
export type PollingStationForSession =
  | (PollingStationFirstSession & { session_type: "First" })
  | (PollingStationNextSession & { session_type: "Next" });

export type PollingStationId = number;

export interface PollingStationInvestigation {
  corrected_results?: boolean;
  data_entry_id?: DataEntryId;
  findings?: string;
  polling_station_id: PollingStationId;
  reason: string;
}

export interface PollingStationInvestigationConcludeRequest {
  corrected_results: boolean;
  findings: string;
}

export interface PollingStationInvestigationCreateRequest {
  reason: string;
}

export interface PollingStationInvestigationUpdateRequest {
  accept_data_entry_deletion?: boolean;
  corrected_results?: boolean;
  findings?: string;
  reason: string;
}

/**
 * Polling station list response
 */
export interface PollingStationListResponse {
  polling_stations: PollingStation[];
}

/**
 * Polling station in a next committee session.
 * May have previous data entries and investigation state.
 */
export type PollingStationNextSession = BasePollingStation & {
  committee_session_id: CommitteeSessionId;
  investigation_status?: InvestigationStatus;
  prev_data_entry_id?: DataEntryId;
};

/**
 * Polling station of a certain [crate::domain::election::Election]
 */
export interface PollingStationRequest {
  address: string;
  locality: string;
  name: string;
  number?: number;
  number_of_voters?: number;
  polling_station_type?: PollingStationType;
  postal_code: string;
}

/**
 * Type of Polling station
 */
export const pollingStationTypeValues = ["FixedLocation", "Special", "Mobile"] as const;
export type PollingStationType = (typeof pollingStationTypeValues)[number];

export interface PollingStationValidateImportResponse {
  polling_station_definition_matches_election: boolean;
  polling_stations: PollingStationRequest[];
}

export interface PollingStationsRequest {
  file_name: string;
  polling_stations: string;
}

export interface PreferenceThreshold {
  number_of_votes: DisplayFraction;
  percentage: number;
}

export type ProcessApportionmentResponse =
  | (ElectionApportionmentResponse & { status: "Finalised" })
  | { election_totals: ElectionTotals; seat_assignment: SeatAssignment; status: "DrawingLotsRequired" };

export type RandomRange = string;

/**
 * Reason for investigation on own initiative
 */
export interface ReasonInvestigationOwnInitiative {
  /** Because of a (suspected) other error
("Vanwege (het vermoeden van) een andere fout") */
  other_error: boolean;
  /** Because of an unaccounted-for difference
("Vanwege een onverklaard verschil") */
  unaccounted_difference: boolean;
}

export interface RedactedEmlHash {
  /** Array holding the hash chunks as text */
  chunks: string[];
  /** Indexes of chunks that will be empty, sorted */
  redacted_indexes: number[];
}

/**
 * Category of a region, as defined by EML-NL
 */
export const regionCategoryValues = [
  "State",
  "WaterAuthority",
  "Province",
  "ElectoralDistrict",
  "Municipality",
  "PollingStation",
] as const;
export type RegionCategory = (typeof regionCategoryValues)[number];

/**
 * Identifies a specific region from the election tree for usage within Abacus.
 */
export interface RegionDetails {
  /** Whether this region allows Frisian export. */
  frisian_export_allowed: boolean;
  /** Key of the region (combination of category and id) */
  key: RegionKey;
  /** Name of the region */
  name: string;
  /** Whether this region uses roman numerals for its contest id. */
  roman_numerals: boolean;
}

/**
 * Identifies a specific region from the election tree for usage within Abacus.
 */
export interface RegionKey {
  /** Category of the region, as defined by EML_NL */
  category: RegionCategory;
  /** Identifier of the region, if it has one. */
  number?: number;
}

/**
 * Political group and its candidates (with registered name as imported from the EML)
 */
export interface RegisteredPoliticalGroup {
  /** List of candidates of the political group */
  candidates: Candidate[];
  /** Political group number */
  number: number;
  /** Registered political group name as imported from the candidates list EML (230) */
  registered_name: string;
}

export const resolveDifferencesActionValues = [
  "keep_first_and_discard_second",
  "keep_first_and_correct_second",
  "keep_second_and_discard_first",
  "keep_second_and_correct_first",
  "discard_both",
] as const;
export type ResolveDifferencesAction = (typeof resolveDifferencesActionValues)[number];

export const resolveErrorsActionValues = ["discard_first_entry", "resume_first_entry"] as const;
export type ResolveErrorsAction = (typeof resolveErrorsActionValues)[number];

/**
 * Results contains the results for a data entry
 *
 * The exact type of results depends on the election counting method,
 * election committee category and whether this is the first or any subsequent data entry session.
 */
export type Results =
  | (DSOFirstSessionResults & { model: "DSOFirstSession" })
  | (NextSessionResults & { model: "DSONextSession" })
  | (CSOFirstSessionResults & { model: "CSOFirstSession" })
  | (NextSessionResults & { model: "CSONextSession" })
  | (GSBResults & { model: "GSB" });

export const roleValues = ["administrator", "coordinator_gsb", "coordinator_csb", "typist_gsb", "typist_csb"] as const;
export type Role = (typeof roleValues)[number];

/**
 * Response structure for saving data entry
 */
export interface SaveDataEntryResponse {
  validation_results: ValidationResults;
}

export interface SeatAssignment {
  full_seats: number;
  quota: DisplayFraction;
  residual_seats: number;
  seats: number;
  standings: ListSeatAssignment[];
  steps: SeatChangeStep[];
}

export type SeatChange =
  | (HighestAverageAssignedSeat & { changed_by: "HighestAverageAssignment" })
  | (HighestAverageAssignedSeat & { changed_by: "UniqueHighestAverageAssignment" })
  | (LargestRemainderAssignedSeat & { changed_by: "LargestRemainderAssignment" })
  | (AbsoluteMajorityReassignedSeat & { changed_by: "AbsoluteMajorityReassignment" })
  | (ListExhaustionRemovedSeat & { changed_by: "ListExhaustionRemoval" });

export interface SeatChangeStep {
  change: SeatChange;
  residual_seat_number?: number;
  standings: ListStanding[];
}

/**
 * Sub electoral committee base entity, independent
 * of the election, committee session and data entry.
 */
export interface SubCommittee {
  authority_id: string;
  authority_name: string;
  category: CommitteeCategory;
  certificates: Certificate[];
  id: SubCommitteeId;
  name: string;
  number: number;
}

/**
 * Sub electoral committee in a first committee session.
 */
export interface SubCommitteeFirstSession {
  authority_id: string;
  authority_name: string;
  committee_session_id: CommitteeSessionId;
  data_entry_id: DataEntryId;
  id: SubCommitteeId;
  name: string;
  number: number;
}

export type SubCommitteeId = number;

/**
 * Contains a sum count, containing both the count and a list of polling
 * stations that contributed to it.
 */
export interface SumCount {
  count: number;
  data_entry_sources: DataEntrySourceNumber[];
}

export interface UpdateUserRequest {
  fullname?: string;
  temp_password?: string;
}

/**
 * User object, corresponds to a row in the users table
 */
export interface User {
  created_at: string;
  fullname?: string;
  id: UserId;
  is_logged_in: boolean;
  last_activity_at?: string;
  role: Role;
  updated_at: string;
  username: string;
}

export type UserId = number;

export interface UserListResponse {
  users: User[];
}

export interface ValidationResult {
  code: ValidationResultCode;
  context?: ValidationResultContext;
  fields: string[];
}

export const validationResultCodeValues = [
  "F101",
  "F102",
  "F103",
  "F104",
  "F111",
  "F112",
  "F121",
  "F122",
  "F131",
  "F132",
  "F133",
  "F134",
  "F135",
  "F201",
  "F202",
  "F203",
  "F204",
  "F301",
  "F302",
  "F303",
  "F304",
  "F305",
  "F306",
  "F307",
  "F308",
  "F309",
  "F310",
  "F311",
  "F312",
  "F313",
  "F401",
  "F402",
  "F403",
  "W001",
  "W002",
  "W201",
  "W202",
  "W203",
  "W204",
  "W205",
  "W206",
] as const;
export type ValidationResultCode = (typeof validationResultCodeValues)[number];

export interface ValidationResultContext {
  political_group_number?: number;
}

export interface ValidationResults {
  errors: ValidationResult[];
  warnings: ValidationResult[];
}

export const voteCountingMethodValues = ["CSO", "DSO"] as const;
export type VoteCountingMethod = (typeof voteCountingMethodValues)[number];

/**
 * Voters counts, part of the results.
 */
export interface VotersCounts {
  /** Number of valid poll cards ("Aantal geldige stempassen") */
  poll_card_count: number;
  /** Number of valid proxy certificates ("Aantal geldige volmachtbewijzen") */
  proxy_certificate_count: number;
  /** Total number of admitted voters ("Totaal aantal toegelaten kiezers") */
  total_admitted_voters_count: number;
  /** Number of valid voter cards ("Aantal geldige kiezerspassen") */
  voter_card_count?: number;
}

/**
 * Votes counts, part of the results.
 * Following the fields in Model CSO Na 31-2 Bijlage 1.
 */
export interface VotesCounts {
  /** Number of blank votes ("Blanco stembiljetten") */
  blank_votes_count: number;
  /** Number of invalid votes ("Ongeldige stembiljetten") */
  invalid_votes_count: number;
  /** Total votes per list */
  political_group_total_votes: PoliticalGroupTotalVotes[];
  /** Total number of valid votes on candidates
("Totaal stemmen op kandidaten") */
  total_votes_candidates_count: number;
  /** Total number of votes cast ("Totaal uitgebrachte stemmen") */
  total_votes_cast_count: number;
}

/**
 * Yes/No response structure for boolean questions with separate yes and no fields.
 */
export interface YesNo {
  no: boolean;
  yes: boolean;
}

export type u32 = number;
